import styled from 'styled-components';

export const PaginationWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['pt', 'pb'].includes(prop),
})`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  column-gap: 48px;
  row-gap: 16px;
  padding-top: ${({ pt }) => pt}px;
  padding-bottom: ${({ pb }) => pb ?? 60}px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    row-gap: 32px;
  }

  a {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.link} !important;
  }

  svg {
    fill: none;
    stroke: ${({ theme }) => theme.colors.link};
  }

  ul {
    width: fit-content;
    display: flex;
    align-items: center;
    column-gap: 15px;

    @media ${(props) => props.theme.device.mobileL} {
      column-gap: 4px;
    }
  }

  li {
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 38px;

    &.selected {
      outline: 2px solid ${({ theme }) => theme.colors.focusSelect};
      outline-offset: -2px;
      border-radius: 4px;

      a {
        color: ${({ theme }) => theme.colors.focusSelect} !important;
      }
    }

    &.disabled {
      color: ${({ theme }) => theme.colors.disabled};
      cursor: default;

      & a {
        cursor: default;
      }
    }

    &.next,
    &.previous {
      display: none;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    cursor: not-allowed;
  }
`;

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  &.disabled {
    svg {
      cursor: default;
      stroke: ${({ theme }) => theme.colors.disabled};
    }
  }
`;

export const SelectWrapper = styled.div`
  max-width: 140px;

  div[class*='-control'] {
    border: none;
    background-color: transparent;
  }

  div[class*='-singleValue'] {
    color: ${({ theme }) => theme.colors.link} !important;
  }

  svg {
    fill: ${({ theme }) => theme.colors.link};
  }
`;

export const PaginationAndGTP = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 64px;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    row-gap: 24px;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 15px;

  @media ${(props) => props.theme.device.mobileL} {
    column-gap: 4px;
  }
`;

export const ItemsPerPage = styled.div`
  display: flex;
  align-items: center;

  @media ${({ theme }) => theme.device.mobileL} {
    order: -1;
  }
`;

export const IPPLabel = styled.div`
  color: #0056ac;
  font-weight: 700;
`;
